.hoverIndicator {
  --vapor-shared-hover-border-radius: var(--radii-6);
  --vapor-shared-hover-transition-duration: 100ms;

  background: var(--colors-background-interactive-hover);
  border-radius: var(--vapor-shared-hover-border-radius);
  left: 0;
  opacity: 1;
  pointer-events: none;
  position: absolute;
  top: 0;
  transform-origin: top left;
  transition:
    transform var(--vapor-shared-hover-transition-duration) linear,
    width var(--vapor-shared-hover-transition-duration) linear,
    height var(--vapor-shared-hover-transition-duration) linear,
    opacity 150ms linear,
    border-radius 75ms linear;

  &:where([data-color='neutral']) {
    background: var(--colors-background-interactive-off-stark);
  }

  &:where([data-entering], [data-exiting]) {
    opacity: 0;
  }
}
